// extracted by mini-css-extract-plugin
module.exports = {"main":"Config_main__3BWgY","backButton":"Config_backButton__1FPzE","container":"Config_container__CRKfN","heading":"Config_heading__VpUFb","btn":"Config_btn__fzd8o"};